import React, {useEffect, useState} from 'react';
import {Card, CardBody, Col, Container, Progress, Row} from "reactstrap";
import {createEvent, createLevels, creatingEventQuestions} from "../user/mainFunction";
import aceLogo from "../../assets/img/brand/ace-logo1.png";
import progressLogo from "../../assets/img/brand/logo-progress.png";
import {collection, doc, getDoc, getDocs, increment, query, updateDoc, where} from "firebase/firestore";
import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";
import {firebaseConstants, getDb} from "util/Constants";
import {useHistory} from 'react-router-dom/cjs/react-router-dom.min';
import {parseInt} from 'lodash';

const Loading = ({userData, signedInUser, metadata}) => {
    const [count, setCount] = useState(0);
    const [step, setStep] = useState("Loading...");
    const history = useHistory();
    const db = getDb();

    const departmentRef = collection(db, firebaseConstants.dbDepartments);
    const regionRef = collection(db, firebaseConstants.dbRegions);

    // const [levels, setLevels] = useState([]);

    useEffect(() => {
        setStep("Creating Event...");
        getQuestionsCount()
        if (userData.eventData.selectedLevels) {
            let miniGames = []
            if (signedInUser.projectType === "progress") {
                miniGames = [...userData.eventData.selectedLevels.games]
            } else {
                miniGames = [...userData.eventData.selectedLevels.cognitive, ...userData.eventData.selectedLevels.aptitude]
            }
            getLevelDifficulty().then((easyLevelScore) => {
                getmeta().then((meta) => {
                    getDepartments_Regions().then((data) => {
                        createEvent(userData.eventData, db, signedInUser, data).then(() => {
                            setCount(10);
                            setStep("Creating Levels...");
                            createLevels(miniGames, userData.eventData.eventId, meta, easyLevelScore, signedInUser.projectType).then(() => {
                                setCount(40);
                                setStep("Adding Questions...");
                                getQuestionsCount().then((result) => {
                                    setCount(55)
                                    getLevels().then(async (_levels) => {
                                        setCount(70)
                                        creatingEventQuestions(userData.eventData.selectedLevels.competencies, _levels, result, userData.eventData.eventId, userData.eventData.difficulty, pushFunction).then((e) => {
                                            let fileURL = ""
                                            const createJSONFile = () => {
                                                const jsonData = JSON.stringify(e, null, 2);
                                                return new Blob([jsonData], {type: "application/json"});
                                            }
                                            const handleUpload = async () => {
                                                const file = createJSONFile();
                                                const storage = getStorage();
                                                // Create a reference to a Firebase Storage location
                                                const storageRef = ref(storage, `events/${userData.eventData.eventId}_questions`);
                                                // Upload the file to the specified Firebase Storage location
                                                await uploadBytes(storageRef, file).then(async () => {
                                                    // Get the download URL of the uploaded file
                                                    await getDownloadURL(storageRef).then((url) => {
                                                        fileURL = url;
                                                    });
                                                });

                                                await updateDoc(doc(db, "Events", userData.eventData.eventId), {
                                                    eventQuestions: fileURL
                                                })
                                                pushFunction()
                                            };
                                            handleUpload()
                                        })
                                        await updateAdmin();
                                    })
                                })
                            })
                        })
                    })
                })
            })
        }

    }, []);
    const getmeta = async () => {
        const docRef = doc(db, "util", "meta");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data()
        } else {
            // docSnap.data() will be undefined in this case
        }
    }
    const getQuestionsCount = async () => {
        const docRef = doc(getDb(), "MetaData_Questions_Count", "analytics");
        const docSnap = await getDoc(docRef);
        let data = {}
        if (docSnap.exists()) {
            data = docSnap.data();
        } else {

        }
        return data
    }
    const getLevels = async () => {
        const dataArr = [];
        const q = query(
            collection(getDb(), "Levels"),
            where('eventId', '==', userData.eventData.eventId),
            where('tabName', '<', 'Mini')
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const data = doc.data();

            dataArr.push({...data});

        });

        return dataArr
    }

    const getLevelDifficulty = async () => {
        try {
            const q = query(
                collection(getDb(), "levelDifficultyScores"),
                where('difficulty', '==', 'Easy'),
            );
            const querySnapshot = await getDocs(q);
            let data = ""
            querySnapshot.forEach((doc) => {
                data = doc.data().passingScore;
            });

            return parseInt(data)
        } catch (e) {
            console.log(e);

        }

    }
    const pushFunction = () => {
        setCount(100)
        history.push('/assessment/congratulation')

    }
    const getDepartments_Regions = async () => {

        try {
            const queryDepartment = await getDocs(departmentRef);
            const queryRegions = await getDocs(regionRef);
            let depArr = [];
            let regionArr = [];
            queryDepartment.forEach((doc) => {
                depArr.push(
                    doc.data().department,
                )
            });
            queryRegions.forEach((doc) => {
                regionArr.push(
                    doc.data().region,
                )
            });

            return {regions: regionArr, departments: depArr}

        } catch (e) {
            console.log(e);

        }


    }

    const updateAdmin = async () => {
        try {
            const docRef = doc(getDb(), "admins", signedInUser.uid);
            await updateDoc(docRef, {newUser: false, assessmentsCount: increment(1)});
        } catch (e) {
            console.log(e);

        }

    }

    return (
        <div>
            <Container className="mt-5">
                <div className="d-flex justify-content-center">
                    <Card className="step1-card br-15">
                        <CardBody className="startCard pt-3">
                            <div className="text-center my-3">
                                <img src={metadata.environment === "progress" ? progressLogo : aceLogo}/>
                            </div>
                            <Row className="mt-5">
                                <Col lg={8}>
                                    <div className="d-flex align-items-center h-100">
                                        <div>
                                            <h2 className="text-center">{step}</h2>
                                            <div className="mt-3 loading-wrapper mb-lg-5" style={{minWidth: "370px"}}>
                                                <Progress
                                                    className="m-3"
                                                    color="loading-bg"
                                                    value={count}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="text-center">
                                    {/*<img src={character} />*/}
                                    <div>
                                        <div className="loadingspinner">
                                            <div id="square1"></div>
                                            <div id="square2"></div>
                                            <div id="square3"></div>
                                            <div id="square4"></div>
                                            <div id="square5"></div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default Loading;
